import { getSkuProductPrices } from 'data/lib/product';

// Only explicitly merchandised product groups share the product card's pricing rules.
export default function categoryProduct(category) {
  if (category.cardPresentation !== 'product-group') return null;

  const products = category.data.flatMap(section => section.products);
  const members = [...new Map(products.flatMap(product => [
    ...product.options,
    ...product.bundles,
  ]).map(member => [member.id, member])).values()];
  const prices = [...new Set(members.flatMap(getSkuProductPrices))].sort((a, b) => a - b);
  if (prices.length === 0) return null;

  return {
    id: category.id,
    name: category.name,
    currency: category.currency,
    images: [{ key: category.image }],
    options: members.filter(member => !member.bundle),
    bundles: members.filter(member => member.bundle),
    prices,
  };
}
